/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_CtaInputs */

const es_home_hero_cta = /** @type {(inputs: Home_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar Gratis`)
};

const en_home_hero_cta = /** @type {(inputs: Home_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Free`)
};

/**
* | output |
* | --- |
* | "Start Free" |
*
* @param {Home_Hero_CtaInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_hero_cta = /** @type {((inputs?: Home_Hero_CtaInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_CtaInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_hero_cta(inputs)
	return en_home_hero_cta(inputs)
});
export { home_hero_cta as "home.hero.cta" }